// extracted by mini-css-extract-plugin
module.exports = {"customPlaceholder":"ContentEditable_customPlaceholder__75Cn2","lightTheme":"ContentEditable_lightTheme__x7IV3"};